<template>
  <div :class="container_class">
    <div :id="pane_container_id" class="pane-container"></div>
    <img
      :src="regular"
      :data-zoom="large"
      class="responsive-image preview-box"
      draggable="false"
    />
  </div>
</template>

<script>
import Drift from "../assets/drift-zoom/src/js/Drift.js";

const getCalculatedPanePosition = (paneStyle = "pane", rect, PanePosition) => {
  let left_position;

  const screen_width = window.innerWidth > 0 ? window.innerWidth : screen.width;

  if (screen_width < 768) {
    left_position = 0;
  } else if (paneStyle == "container") {
    left_position = 0;
  } else if (PanePosition == "left") {
    left_position = 0 - rect.width - window.scrollX - 5;
  } else if (PanePosition == "right") {
    left_position = rect.width + window.scrollX - 5;
  }
  return `width: ${rect.width}px; height: ${rect.height}px; left: ${left_position}px;`;
};

export default {
  name: "ProductZoomer",
  props: {
    baseZoomerOptions: {
      type: Object,
      default: function () {
        return {};
      },
    },
    regular: {
      type: String,
      required: true,
    },
    large: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      drift: null,
      options: {
        zoomFactor: 4,
        pane: "container",
        hoverDelay: 300,
        namespace: "container-zoomer",
        move_by_click: true,
        zoomer_pane_position: "right",
      },
    };
  },
  computed: {
    /**
     * @returns {string}
     */
    container_class: function () {
      return `${this.options.namespace}-base-container`;
    },
    base_container_div: function () {
      return document.querySelector("." + this.container_class);
    },
    pane_container_id: function () {
      return this.options.namespace + "-pane-container";
    },
    preview_img: function () {
      return `.${this.container_class} .preview-box`;
    },
  },
  mounted() {
    if (!["left", "right"].includes(this.options.zoomer_pane_position)) {
      throw "zoomer_pane_position is invalid";
    }
    this.$nextTick(() => {
      this.options.injectBaseStyles = true;
      if (this.options.pane === "container-round") {
        this.options.inlinePane = true;
      } else {
        this.options.inlinePane = false;
        this.options.paneContainer = document.getElementById(
          this.pane_container_id
        );
        this.options.onHide = () => {
          document.querySelector(`.product_main`).style.visibility = "";
        };
        this.options.onShow = () => {
          document.querySelector(`.product_main`).style.visibility = "hidden";
          let rect = document
            .querySelector(`.${this.container_class}`)
            .getBoundingClientRect();
          document
            .getElementById(this.pane_container_id)
            .setAttribute(
              "style",
              getCalculatedPanePosition(
                this.options.pane,
                rect,
                this.options.zoomer_pane_position
              )
            );
        };
      }
      this.drift = new Drift(
        document.querySelector(this.preview_img),
        this.options
      );
    });
  },
  created() {
    if (Object.keys(this.baseZoomerOptions).length > 0) {
      for (const key in this.baseZoomerOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, key)) {
          const element = this.baseZoomerOptions[key];
          this.options[key] = element;
        }
      }
    }

    if (
      this.options.pane === "container-round" ||
      this.options.pane === "container"
    ) {
      this.options.hoverBoundingBox = false;
    } else {
      this.options.hoverBoundingBox = true;
    }
  },
  methods: {},
};
</script>
<style>
@import "../assets/drift-zoom/src/css/drift-basic.css";
</style>

<style scoped>
.zoomer-control {
  cursor: pointer;
}
.pane-container {
  display: none;
  position: absolute;
  z-index: 100;
  pointer-events: none;
}
.responsive-image {
  max-width: 100%;
}
</style>